<template>
  <vx-card title="Клики">
    <div class="mb-6">
      <IconWithStatistics
        :customIcon="require('../../../assets/images/whatsapp-icon.svg')"
        title="Переходы в WhatsApp"
        :count="total"
        color="#29c76f"
      />
    </div>
  </vx-card>
</template>

<script>
import IconWithStatistics from './IconWithStatistics'

export default {
  props: {
    clicks: {
      required: true,
      type: Object
    }
  },

  components: {
    IconWithStatistics
  },

  data () {
    const chat_api = this.clicks.chat_api || 0
    const gupshup = this.clicks.gupshup || 0
    const total = chat_api + gupshup

    return {
      chat_api,
      gupshup,
      total
    }
  },

  methods: {
    getPercent (a) {
      return a * 100 / this.total_messages_count
    }
  }
}
</script>
